<template>
  <div class="search-wrap">
    <div class="search-top">
      <div class="container">
        <div class="search-form-body">
          <div class="search-form">
            <form @submit.prevent="goToSearchNPA">
              <input
                type="text"
                v-model="name"
                class="form-control"
                :placeholder='$t("Поиск")'
              />
            </form>
            <button class="btn search-btn" @click="goToSearchNPA">
              <i class="pro-icon-magnifying-glass"></i>
            </button>
          </div>
          <div class="advanced-search">
            <a href="#" @click="goToSearchNPA">{{ $t("Расширенный поиск проекта") }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Trans } from "@/plugins/Translation"

export default {
  data: () => ({
    name: ''
  }),
  methods: {
    goToSearchNPA() {
      if (this.name !== '') {
        this.$router.push(Trans.currentLocaleUrl + '/search-npa?name=' + this.name)
      } else {
        this.$router.push(Trans.currentLocaleUrl + '/search-npa')
      }
    }
  }
}
</script>
